import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../../../components/fela/Box';
import сomponentsStyles from './suggestion-custom.style';

export interface ISharedProps {
  notAButton?: boolean;
}

interface PropTypes extends ISharedProps {
  customSuggestLabel?: string;
}

const SuggestionCustom: FunctionComponent<PropTypes> = ({ customSuggestLabel, notAButton }) => {
  const { t } = useTranslation('ui');
  const styles = сomponentsStyles({ notAButton });

  return (
    <Box as={notAButton ? 'div' : 'button'} style={styles.wrapper}>
      <Box style={styles.missing}>{t('suggestionCustom.supplierNotListed')}</Box>
      <Box style={styles.getAdded}>{customSuggestLabel || t('suggestionCustom.addManually')}</Box>
    </Box>
  );
};

export default SuggestionCustom;
